export default __webpack_public_path__ + "static/media/icon_red_ambulatoria_off.0a30e20d.svg";